import React from 'react';
import styled from 'styled-components';

import { colorTokens } from '../../../tokens/globals/tokens';

import { menuHeight } from '../constants';
import { SpreadsheetCallbackType, SpreadsheetMenuType } from '../types';

const SpreadsheetMenuWrapper = styled.div`
  align-items: center;
  background-color: ${colorTokens.GlobalBrandWhite};
  border-left: 1px solid ${colorTokens.GlobalBrandGray40};
  border-top: 1px solid ${colorTokens.GlobalBrandGray40};
  display: flex;
  grid-column: 1 / span 2;
  grid-row: 1;
  height: ${menuHeight}px;
  justify-content: space-between;
  max-height: ${menuHeight}px;
  min-height: ${menuHeight}px;
  padding: 12px 20px;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 182;
`;

interface SpreadsheetMenuProps {
  callbacks: SpreadsheetCallbackType;
  children: SpreadsheetMenuType;
  id?: string;
}

function SpreadsheetMenu(props: SpreadsheetMenuProps) {
  const { children: MenuChildComponent, ...otherProps } = props;
  return (
    <SpreadsheetMenuWrapper {...otherProps} role="toolbar">
      <MenuChildComponent {...props.callbacks} />
    </SpreadsheetMenuWrapper>
  );
}

export { SpreadsheetMenu };
